// Which pages show the bottom bar. The start, welcome, ended, projector, editor and import
// pages are full-screen, and so is the live page: the host has the sheet there and a guest
// the lyrics alone (the live bar above the tabs leads back to it from every other page).
const TABBED = [/^\/songs$/, /^\/songs\/\d+$/, /^\/library$/, /^\/sets$/, /^\/sets\/\d+$/, /^\/queue$/, /^\/join$/, /^\/settings$/, /^\/issues$/];

const FULL_SCREEN = ["/", "/welcome", "/ended", "/screen"];

/** A share link like /ABCDE (joined on arrival, no bar). */
export const isJoinLink = (pathname) => /^\/[A-Za-z0-9]{5}$/.test(pathname) && !TABBED.some((route) => route.test(pathname));

export const showsTabs = (pathname, { hasSession }) => Boolean(hasSession) && TABBED.some((route) => route.test(pathname));

/** The live bar sits above the tabs on every page that has them (the live page has none). */
export const showsLiveBar = (pathname, options) => showsTabs(pathname, options) && pathname !== "/lyrics";

/** The offline banner belongs to the session pages, not to the start, welcome, ended or projector pages. */
export const showsBanner = (pathname, { hasSession }) =>
  Boolean(hasSession) && !FULL_SCREEN.includes(pathname) && !isJoinLink(pathname);

export const tabsFor = (isHost) => [
  { to: "/songs", glyph: "⌕", label: "Songs" },
  { to: "/library", glyph: "♥", label: "Favorites" },
  { to: "/sets", glyph: "☰", label: "Sets" },
  isHost ? { to: "/lyrics", glyph: "⊙", label: "Live" } : { to: "/join", glyph: "⊙", label: "Join" },
];

export const isTabActive = (tab, pathname) => {
  if (tab.to === "/songs") return pathname === "/songs" || /^\/songs\/\d+$/.test(pathname);
  if (tab.to === "/sets") return pathname.startsWith("/sets") || pathname === "/queue";
  return pathname === tab.to;
};
